export default "__VITE_ASSET__BZcb_Na5__"